// extracted by mini-css-extract-plugin
export default {"wrapper":"LogoCard_wrapper__73T8d","logos":"LogoCard_logos__XDxuq","logo":"LogoCard_logo__F3izn","onLoad":"LogoCard_onLoad__xNDs7"};